import { addNavMenuItem, registerBulkAction } from '@vendure/admin-ui/core';
import {
    assignPromotionsToChannelBulkAction,
    deleteCouponsBulkAction,
    duplicatePromotionsBulkAction,
    removePromotionsFromChannelBulkAction,
} from './components/coupon-list/coupon-list-bulk-actions';

export default [
    addNavMenuItem(
        {
            id: 'coupon-codes',
            label: 'Coupon Codes',
            icon: 'asterisk',
            routerLink: ['/extensions/coupon-codes'],
        },
        'marketing',
    ),
    registerBulkAction(deleteCouponsBulkAction),
    registerBulkAction(assignPromotionsToChannelBulkAction),
    registerBulkAction(removePromotionsFromChannelBulkAction),
    registerBulkAction(duplicatePromotionsBulkAction),
];
